export const isTouchedDevice = () => {
  return 'ontouchstart' in document.documentElement
}

export const doesBrowserSupportNativeTimeInput = () => {
  const input = document.createElement('input')
  input.setAttribute('type', 'time')

  const notATimeValue = 'not-a-time'
  input.setAttribute('value', notATimeValue)

  return (input.value !== notATimeValue)
}

export const doesBrowserSupportNativeDateInput = () => {
  const input = document.createElement('input')
  input.setAttribute('type', 'date')

  const notADateValue = 'not-a-date'
  input.setAttribute('value', notADateValue)

  return (input.value !== notADateValue)
}
